import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const leftMenu = [
  {
    icon: mediaUrls.dashboard,
    label: 'leftMenu.dashboard',
    path: '/dashboard',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'dashboard',
  },
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'DRIVER'],
    path: '/logs/list',
    feature: 'log',
  },
  {
    icon: mediaUrls.user,
    label: 'leftMenu.users',
    roles: ['FLMANAGER'],
    path: '/user/list',
    feature: 'user',
  },
  {
    icon: mediaUrls.vehicle,
    label: 'leftMenu.vehicles',
    roles: ['FLMANAGER'],
    path: '/vehicle/list',
    feature: 'vehicle',
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    path: '/report',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'reportsEnabled',
    feature: 'report',
  },
  {
    icon: mediaUrls.company,
    label: 'leftMenu.companyData',
    path: '/company/edit',
    roles: ['FLMANAGER', 'ADMIN'],
    module: 'companyDataEdit',
  },
  {
    icon: mediaUrls.dotAuditIcon,
    label: 'leftMenu.DOTAudit',
    roles: ['FLMANAGER'],
    path: '/logs/fmcsaLogs',
    feature: 'fmcsa',
  },
  {
    icon: mediaUrls.viewDocument,
    label: 'leftMenu.documents',
    roles: ['FLMANAGER'],
    path: '/company/document/edit',
  },
  {
    icon: mediaUrls.dailyDocuments,
    label: 'leftMenu.dailyDocuments',
    roles: ['FLMANAGER'],
    path: '/dailyDocuments/list',
    feature: 'dailyDocuments',
  },
  {
    icon: mediaUrls.downloadCenterMenu,
    label: 'leftMenu.downloadCenter',
    roles: ['FLMANAGER', 'ADMIN'],
    path: '/downloadCenter/list',
    module: 'downloadCenterEnabled',
  },
  {
    icon: mediaUrls.fuel,
    label: 'leftMenu.fuelReport',
    roles: ['FLMANAGER'],
    path: '/fuel/list',
    feature: 'fuel',
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    path: '/policy/edit',
    roles: ['FLMANAGER', 'ADMIN'],
    feature: 'policy',
  },
];
export default leftMenu;
